import { render, staticRenderFns } from "./CreateEventCategoryModal.vue?vue&type=template&id=f319cf06&scoped=true"
import script from "./CreateEventCategoryModal.vue?vue&type=script&lang=js"
export * from "./CreateEventCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEventCategoryModal.vue?vue&type=style&index=0&id=f319cf06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f319cf06",
  null
  
)

export default component.exports